<div class="inline-date-picker-wrapper">
  @if (!isEditing) {
    <span class="left">
      @if (selectedValue === null) {
        <a (click)="toggleEdit()" class="add-date"> Select Answer </a>
      }
      @if (selectedValue !== null) {
        <span>
          {{ formattedAnswer }}
        </span>
      }
      @if (selectedValue !== null) {
        <button class="edit-button" mat-icon-button (click)="toggleEdit()">
          <mat-icon class="edit-icon">edit</mat-icon>
        </button>
      }
    </span>
  }
  <div
    class="editing"
    [ngClass]="{
      hidden: !isEditing
    }"
    >
    <mat-button-toggle-group class="button-group" [(ngModel)]="value">
      <mat-button-toggle value="Yes">Yes</mat-button-toggle>
      <mat-button-toggle value="No">No</mat-button-toggle>
    </mat-button-toggle-group>
    <div class="button-container">
      <button mat-button (click)="toggleEdit()">CANCEL</button>
      <button mat-button class="save" (click)="onSave()">SAVE</button>
    </div>
  </div>
</div>
